/* eslint-disable no-shadow */
import { FormFields, FormFieldsErrors, FormValidationSchema } from '../../common/interfaces';

export enum PageLayoutsFormInputs {
  Name = 'name',
  Content = 'content'
}

export type PageLayoutsFormFields = FormFields<typeof PageLayoutsFormInputs>;

export type PageLayoutsFormValidationSchema = FormValidationSchema<PageLayoutsFormFields>;

export type PageLayoutsFormFieldsErrors = FormFieldsErrors<typeof PageLayoutsFormInputs>;
